import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-content {
      padding: 32px;
    }

    .ant-modal-header {
      margin-bottom: 24px;
    }

    .ant-modal-title {
      font-size: 18px;
      font-weight: 700;
    }

    .ant-modal-body {
      height: 40vh;
      overflow: auto;
    }

    .ant-modal-footer {
      margin-top: 24px;
    }

    .page-marketing {
      min-width: 964px;
      padding: unset;

      h4 {
        display: none;
      }
    }
  }
`;

export default StyledModal;
